import { render, staticRenderFns } from "./KernelPackageReturnHistory.vue?vue&type=template&id=266f368b&"
import script from "./KernelPackageReturnHistory.vue?vue&type=script&lang=js&"
export * from "./KernelPackageReturnHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports